module.exports = __webpack_public_path__ + "static/media/hw_mo_35.d18091db.flv";